
/**
 * Created by Jayson Amodia
 */

import React from 'react'
import { NavLink, useLocation } from 'react-router-dom'
import { mpe_ael_point_cw, mpe_ael_point_single_pulse, mpe_ael_point_repetitively_pulsed, mpe_ael_extended_cw, mpe_ael_extended_single_pulse, mpe_ael_extended_repetitively_pulsed, fiberOptic_single_mode_cw, fiberOptic_single_mode_singlePulse, fiberOptic_single_mode_repetitively_pulsed, diffuseReflective_cw, diffuseReflective_single_pulse, diffuseReflective_repetitively_pulsed, lookupTableValues } from '../FreePresetValues/free'
import { Flex, Tooltip, Typography } from 'antd'

/**
 * 
 * @param {*} calculatorType mpe_ael, fiberOptic or diffuseReflective in string.
 * @returns 
 */
const useFreeMode = (calculatorType) => {
    if (!calculatorType) throw new Error('Calculator type is required to use useFreeMode hook!')
    const { pathname } = useLocation()

    const isFree = (() => {
        // console.log(`mashy: `, pathname)
        if (pathname.endsWith('/free/') || pathname.endsWith('/free')) {
            // console.log(`mashy: isFree!`)
            return true
        } else {
            // console.log(`mashy: Is not free!`)
            return false
        }
    })()

    /**
     * A method that takes in laserOperation and sourceType and manipulates the form to change its values.
     * @param {*} calculatorType mpe_ael, fiberOptic or diffuseReflective
     * @param {*} sourceType point or extended.
     * @param {*} laserOperation cw, singlePulse or repetitivelyPulsed.
    */
    const selectInitialValues = (sourceType, laserOperation, form) => {
        const actions = {
            "mpe_ael:point:cw": mpe_ael_point_cw,
            "mpe_ael:point:singlePulse": mpe_ael_point_single_pulse,
            "mpe_ael:point:repetitivelyPulsed": mpe_ael_point_repetitively_pulsed,
            "mpe_ael:extended:cw": mpe_ael_extended_cw,
            "mpe_ael:extended:singlePulse": mpe_ael_extended_single_pulse,
            "mpe_ael:extended:repetitivelyPulsed": mpe_ael_extended_repetitively_pulsed,

            "fiberOptic:singlemode:FO_cw": fiberOptic_single_mode_cw,
            "fiberOptic:singlemode:FO_singlePulse": fiberOptic_single_mode_singlePulse,
            "fiberOptic:singlemode:FO_repetitivelyPulsed": fiberOptic_single_mode_repetitively_pulsed,

            "diffuseReflective:point:diffuseReflectiveCW": diffuseReflective_cw,
            "diffuseReflective:point:diffuseReflectiveSinglePulse": diffuseReflective_single_pulse,
            "diffuseReflective:point:diffuseReflectiveRepetitivelyPulsed": diffuseReflective_repetitively_pulsed,

            "lookupTable:any:any": lookupTableValues
        }

        const key = `${calculatorType}:${sourceType}:${laserOperation}`
        if (actions[key]) {
            // console.log(`Have you: `, actions[key])
            form.resetFields()
            form.setFieldsValue(actions[key])
        } else {
            throw new Error(`Unknown combination! ${sourceType}-${laserOperation}`)
        }
    }

    const handleLaserOperationOrSourceTypeChange = (form) => {
        const laserOperation = form.getFieldValue(['laserOperation'])
        const sourceType = form.getFieldValue(['sourceType'])
        if (isFree) {
            selectInitialValues(sourceType, laserOperation, form)
        }
    }

    /**
     * 
     * @param {*} param0 
     * @param {*} tooltipText element that will appear on the body of the tooltip.
     * @returns If in free mode, wraps the 
     */
    const FreeModeWrapper = ({ children }) => {
        // if (!tooltipText) throw new Error('Free Mode Wrapper was used but no tool tip text was assigned!')
        if (!isFree) {
            return <>{children}</>
        } else {
            return <Tooltip title={<>Available in the <NavLink to='/home'>Premium version of RealTime LSS</NavLink>.</>}>{children}</Tooltip>
        }
    }


    const FreeModeDisclaimer = () => {
        if (isFree) {
            return (
                <Flex justify='center' style={{ margin: '0 0 24px' }}>
                    <Typography.Text type='secondary'>
                        You are currently using the <strong>Free Version</strong> of the calculator. This version uses pre-set values that cannot be modified.
                        To unlock full customization and for a more detailed result, please upgrade to the <NavLink to='/home'>Premium Version</NavLink>.
                    </Typography.Text>
                </Flex>
            )
        }
    }

    return { isFree, selectInitialValues, handleLaserOperationOrSourceTypeChange, FreeModeWrapper, FreeModeDisclaimer }
}



export default useFreeMode
